module.exports = __webpack_public_path__ + "img/youxuepai.e05a31af.webp";